import { supabase } from '@/lib/supabase';

export async function getProjectOrgIds(
  projectIds: number[],
): Promise<Map<number, number>> {
  if (projectIds.length === 0) return new Map();

  try {
    const { data, error } = await supabase.rpc('get_project_org_ids_batch', {
      p_project_ids: projectIds,
    });

    // If there's an error, return empty map
    // This allows charts to still render, just without partner names
    if (error) {
      return new Map();
    }

    const map = new Map<number, number>();
    data?.forEach((row) => {
      if (row.org_id) map.set(row.project_id, row.org_id);
    });
    return map;
  } catch {
    return new Map();
  }
}
